import React, { useCallback } from 'react'

import type { AdapterKitControlProps } from 'components/formKit/types'
import type { IRadioProps, RadioValueType } from 'components/uiKit/Radio'
import Radio from 'components/uiKit/Radio'

const FieldRadio = <V extends RadioValueType>({
  name,
  onChange,
  ...rest
}: AdapterKitControlProps<IRadioProps<V>, V>) => {
  const handleChange = useCallback((value: V) => onChange({ name, value }), [name, onChange])

  return <Radio {...rest} name={name} onChange={handleChange} />
}

export default React.memo(FieldRadio) as typeof FieldRadio
